<template lang="pug">
  v-flex
    v-container
      v-layout
        v-text-field(v-model='search' prepend-icon='fa-search' label='Buscar código' single-line hide-details)
      v-layout.mt-4   
          h2 Cuentas por pagar
          v-spacer
          cuentas_por_pagar
      v-layout.mt-4
          v-flex
              v-data-table.elevation-1(group-by="referencia"  item-key='key' show-group-by  show-select v-model='state.seleccionar' :headers="headers_cuentas" :search='search' :items='r1')
      v-layout.mt-4
            h2 Pagos  
      v-layout.mt-4
        v-flex
            v-data-table.elevation-1(:headers='header_pagos' :search='search' :items='r2')
                template(v-slot:item.action='props')
                  cuentas_por_pagar(:objeto='props.item')

</template>
<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import {customAuth} from '@/FirebaseConfig'
export default {
    data: ()=>({
        search: '',
        singleSelect: true,
        headers_cuentas: [
            { text: 'Código',                   value: 'codigo', sortable: false },       
            { text: 'Monto',              value: 'haber', sortable: false},              
            { text: 'Creado por',              value: 'creado_por', sortable: false},
            { text: 'Creado el',              value: 'creado_el'},
            { text: 'Proveedor', value: 'proveedor', sortable: false},
            {text: 'Referencia', value: 'referencia', sortable: false},
            { text: 'Pagar cuenta', align: 'center', value: 'action', sortable: false}
        ],
        header_pagos: [
            {text: 'Código',                   value: 'codigo', sortable: false},
            {text: 'Monto', value: 'haber', sortable: false},
            {text: 'Creador por', value: 'creado_por', sortable: false},
            {text: 'Creado el', value: 'creado_el', sortable: false},
            {text: 'Proveedor', value: 'proveedor', sortable: false},
        ],
        r1: [],
        r2: []
    }),
    methods: {
     
    },
    watch:{
      async 'db_activada'(){
        this.r1 = await this.$store.dispatch('Cuentas_por_pagar/getAll', ({cuenta_o_pago: true}) ) 
        this.r2  = await this.$store.dispatch('Cuentas_por_pagar/getAll', ({cuenta: '1'}))
        
      }
    },
    async created(){
      if(this.db_activada){
        this.r1 =  await this.$store.dispatch('Cuentas_por_pagar/getAll', ({cuenta_o_pago: true}) ) 
        this.r2 = await this.$store.dispatch('Cuentas_por_pagar/getAll', ({cuenta: '1'}))          
      }
    },
    computed:{
      ...mapState({
        db_activada: state => state.Customers.db_activada,
        state: state=>state.Cuentas_por_pagar
      })
    },
    components: {
        cuentas_por_pagar: ()=>import('../../contable/componentes/cuenta_por_pagar')
    },
    methods: {
      prueba(){
        console.log(this.state.seleccionar)
      }
    }
}
</script>
